import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-900 hover:text-accent-500 transition-colors"
        >
          <span className="font-heading text-xl font-bold tracking-tight">
            Kakobuy<span className="text-accent-500">Polska</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line mr-1"></i>
            Strona główna
          </Link>
          <a
            href="#categories"
            className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            Kategorie
          </a>
          <a
            href="#about"
            className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            O Spreadsheet
          </a>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-poradnik"
            className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            <i className="ri-book-open-line mr-1"></i>
            Poradnik zakupowy
          </Link>
          <a
            href="#artykuly"
            className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            Artykuły
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer relative z-50"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl transition-all ${mobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="px-4 py-6 flex flex-col gap-1">
            <div className="mb-3">
              <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider px-3 mb-2">Nawigacja</p>
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line text-base w-5 h-5 flex items-center justify-center"></i>
                Strona główna
              </Link>
              <a
                href="#about"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-information-line text-base w-5 h-5 flex items-center justify-center"></i>
                Czym jest Spreadsheet
              </a>
              <a
                href="#why-choose"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-thumb-up-line text-base w-5 h-5 flex items-center justify-center"></i>
                Dlaczego warto
              </a>
              <a
                href="#safety"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-shield-check-line text-base w-5 h-5 flex items-center justify-center"></i>
                Bezpieczeństwo
              </a>
              <a
                href="#artykuly"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-article-line text-base w-5 h-5 flex items-center justify-center"></i>
                Artykuły SEO
              </a>
            </div>

            <div className="border-t border-background-200/60 pt-3 mb-3">
              <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider px-3 mb-2">Poradniki zakupowe</p>
              <Link
                to="/artykul/kakobuy-spreadsheet-polska-poradnik"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-book-open-line text-base w-5 h-5 flex items-center justify-center"></i>
                Poradnik główny 2026
              </Link>
              <Link
                to="/artykul/jak-bezpiecznie-kupowac-kakobuy"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-shield-line text-base w-5 h-5 flex items-center justify-center"></i>
                Bezpieczne zakupy
              </Link>
              <Link
                to="/artykul/kakobuy-dla-poczatkujacych"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-user-smile-line text-base w-5 h-5 flex items-center justify-center"></i>
                Dla początkujących
              </Link>
              <Link
                to="/artykul/koszty-wysylki-kakobuy-polska"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-truck-line text-base w-5 h-5 flex items-center justify-center"></i>
                Koszty wysyłki
              </Link>
            </div>

            <div className="border-t border-background-200/60 pt-3 mb-3">
              <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider px-3 mb-2">Kategorie produktów</p>
              <div className="grid grid-cols-2 gap-1 px-1">
                {[
                  { name: 'Shoes', slug: 'category-911-Shoes.html' },
                  { name: 'Hoodies / Sweaters', slug: 'search-912/name/Shoes.html' },
                  { name: 'T-Shirts', slug: 'search-913/name/Shoes.html' },
                  { name: 'Jackets', slug: 'search-914/name/Shoes.html' },
                  { name: 'Pants / Shorts', slug: 'search-915/name/Shoes.html' },
                  { name: 'Headwear', slug: 'search-916/name/Shoes.html' },
                  { name: 'Sets', slug: 'search-917/name/Shoes.html' },
                  { name: 'Underwear', slug: 'search-918/name/Shoes.html' },
                  { name: 'Jersey', slug: 'search-919/name/Shoes.html' },
                  { name: 'Accessories', slug: 'search-920/name/Shoes.html' },
                  { name: 'Bags', slug: 'search-921/name/Shoes.html' },
                  { name: 'Belts', slug: 'search-922/name/Shoes.html' },
                  { name: 'Perfumes', slug: 'search-923/name/Shoes.html' },
                  { name: 'Other Stuff', slug: 'search-924/name/Shoes.html' },
                ].map((cat) => (
                  <a
                    key={cat.name}
                    href={`https://kaspreadsheet.com/${cat.slug}`}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center gap-2 px-2 py-2 text-xs text-foreground-600 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0"></span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="border-t border-background-200/60 pt-4 px-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-base"></i>
                Kakobuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3 mt-3 border border-accent-500 text-accent-600 rounded-full text-sm font-semibold hover:bg-accent-50 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line text-base"></i>
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}